module.exports = __webpack_public_path__ + "media/images/pic/saska/team/teachers/anna-adamczyk-rucel-c8bfccd8856a80214dbd753ecb2e5ece.webp";